import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 1.9 },
  { title: 'Ativo', flex: 1.9 },
  { title: 'Data da cota' },
  { title: 'Valor da cota anual' },
  { title: 'Qtde. cotas' },
  { title: 'Valor bruto' },
  { title: 'Valor líquido' },
];

export const getFundsFilters = (
  dynamicFilters: FilterModalTypes.FilterType[]
): FilterModalTypes.FilterType[] => [
  {
    type: 'date',
    fieldName: 'quoteDate',
    title: 'Data da cota',
    placeholder: 'Selecione a data da cota',
  },
  ...dynamicFilters,
  {
    type: 'range',
    fieldName: 'currentQuoteValue',
    labelType: 'money',
    title: 'Valor da cota atual',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'units',
    labelType: 'number',
    title: 'Quantidade de cotas',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'grossValue',
    labelType: 'money',
    title: 'Valor bruto',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'netValue',
    labelType: 'money',
    title: 'Valor líquido',
    min: 0,
    max: 1000000000,
  },
];
